import React from 'react';
import { Block } from '@klp/design/Block';
import { Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';
import { useProsjektSammendragContext } from './context/ProsjektSammendragProvider';

export const ProsjektSammendragAvvistKommentar: React.FC = () => {
    const { t } = useTranslation();
    const { selectedProcess } = useProsjektSammendragContext();
    if (!selectedProcess?.avvistKommentar) return null;

    const avvistOppgaveNavn = selectedProcess.aktiviteter?.findLast(
        (a) => a.utfortDato,
    )?.navn;

    return (
        <Block paddingVertical="compact">
            <Alert severity="warning">
                <Typography
                    variant="body1"
                    data-testid="ProsjektSammendragAvvistKommentar__OppgaveNavn"
                    data-testname={avvistOppgaveNavn}
                >
                    <strong>
                        {t('prosjekt.avvistKommentarTitle', {
                            avvistOppgave: avvistOppgaveNavn,
                        })}
                    </strong>
                </Typography>
                <Typography variant="body1">
                    {selectedProcess.avvistKommentar}
                </Typography>
            </Alert>
        </Block>
    );
};
